import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'
import { isDevServer, serverForImages } from '../../../config'
import { useAppContext } from '../../../context/siteMapContext'
import { imageLoader } from '../../../context/utils'

export interface IIconWrapperProps {
  name: string
  iconColor: string
  fontColor: string
  iconUrl?: string
  large?: boolean;
  tabIndex?: boolean,
  inHeader?: boolean
}

const IconWrapper: React.FC<IIconWrapperProps> = ({
  name,
  iconColor = '#fff',
  fontColor,
  iconUrl,
  large,
  tabIndex,
  inHeader
}) => {
  const { highContrastOn } = useAppContext();
  const svg = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isDevServer && iconUrl?.slice(-3) === 'svg') {
      fetch(serverForImages + iconUrl, {
        method: 'GET',
      }).then(content => content.text()).then(content => {
        const element = svg.current as HTMLElement;
        if (element) {
          element.innerHTML = content;
          const svg = element.getElementsByTagName('svg')?.[0];
          element.getElementsByTagName('defs')?.[0]?.remove();
          svg.style.height = '100%';
          svg.style.margin = 'auto';
          Array.from(svg.getElementsByTagName('path')).forEach(p => { p.style.fill = highContrastOn ? (inHeader ? 'white' : 'black') : iconColor });
          Array.from(svg.getElementsByTagName('polygon')).forEach(p => { p.style.fill = highContrastOn ? (inHeader ? 'white' : 'black') : iconColor });
          Array.from(svg.getElementsByTagName('circle')).forEach(p => { p.style.fill = highContrastOn ? (inHeader ? 'white' : 'black') : iconColor });
          Array.from(svg.getElementsByTagName('rect')).forEach(p => { p.style.fill = highContrastOn ? (inHeader ? 'white' : 'black') : iconColor });
        }
      })
    }
  }, [iconColor, iconUrl, highContrastOn, inHeader])

  return (
    <div className='flex flex-col items-center justify-start h-full card-wrap justify-center' tabIndex={tabIndex ? 0 : undefined}>
      {iconUrl && (
        <>
          {(!isDevServer && iconUrl?.slice(-3) === 'svg') &&
            <div title={name} ref={svg} className={`relative mb-6 flex h-small-icon w-small-icon ${large ? '2xl:h-large-icon 2xl:w-large-icon' : ''}`}>
            </div>
          }
          {(isDevServer || iconUrl?.slice(-3) !== 'svg') &&
            <div className={`relative mb-6 flex h-small-icon w-small-icon ${large ? '2xl:h-large-icon 2xl:w-large-icon' : ''}`}>
              <Image
                loader={imageLoader}
                src={iconUrl}
                alt={name}
                layout="fill"
                title={name}
              />
            </div>
          }
        </>
      )}
      <div className='flex items-center justify-center'>
        <h1
          style={{ color: highContrastOn ? (inHeader ? '#fff' : '#000') : (fontColor || '#fff') }}
          className='font-montserrat font-semibold text-card text-card-label 2xl:text-card-label-2xl text-center'
        >
          {name}
        </h1>
      </div>
    </div>
  )
}

export default IconWrapper
